const STATUS_STYLES: Record<string, string> = {
  持续发酵: 'bg-primary-100 text-primary-700 border-primary-200',
  已反转: 'bg-accent-100 text-accent-900 border-accent-300',
  待回应: 'bg-secondary-100 text-secondary-900 border-secondary-200',
  已归档: 'bg-background-200 text-foreground-700 border-background-300',
};

export default function StatusBadge({ status, className = '' }: { status: string; className?: string }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES['已归档'];
  return (
    <span
      className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-medium ${style} ${className}`}
    >
      <i className="ri-pulse-line text-[13px]"></i>
      {status}
    </span>
  );
}